import { render, staticRenderFns } from "./visitManageList.vue?vue&type=template&id=04d81830&scoped=true"
import script from "./visitManageList.vue?vue&type=script&lang=js"
export * from "./visitManageList.vue?vue&type=script&lang=js"
import style0 from "./visitManageList.vue?vue&type=style&index=0&id=04d81830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d81830",
  null
  
)

export default component.exports